module.exports = __webpack_public_path__ + "static/media/AllGames.1d3fb636.png";